<section class="page">
  <header class="page-header">
    <h2>Vérifier les livraisons</h2>
    <p class="subtitle">Déclenche la vérification des livraisons capteurs et cartouches via le service check-livraisons.</p>
  </header>

  <section class="panel">
    <div class="actions-row">
      <button type="button" [disabled]="running" (click)="runCheck()">
        {{ running ? 'Vérification en cours...' : 'Lancer la vérification' }}
      </button>
      <a class="action-link" routerLink="/intranet/gestion-stocks/capteurs/voir">Voir les capteurs</a>
      <a class="action-link" routerLink="/intranet/gestion-stocks/cartouches/voir">Voir les cartouches</a>
    </div>

    @if (lastRunAt) {
      <p class="meta">Dernier lancement: {{ lastRunAt | date: 'dd/MM/yyyy HH:mm:ss' }}</p>
    }

    @if (error) {
      <p class="error">{{ error }}</p>
    }
  </section>

  @if (result; as currentResult) {
    <section class="panel">
      <h3>Résultat</h3>

      <div class="summary-grid">
        <article>
          <span class="label">Capteurs analysés</span>
          <strong>{{ currentResult.scanned }}</strong>
        </article>
        <article>
          <span class="label">Livraisons de capteurs mises à jour</span>
          <strong>{{ currentResult.updatedCapteurs }}</strong>
        </article>
        <article>
          <span class="label">Cartouches marquées livrées</span>
          <strong>{{ currentResult.markedCartouchesLivrees }}</strong>
        </article>
        <article>
          <span class="label">Appels à l'API Laposte</span>
          <strong>{{ currentResult.trackingCalls }}</strong>
        </article>
      </div>

      @if (currentResult.errors.length > 0) {
        <h3>Erreurs</h3>
        <ul class="errors-list">
          @for (item of currentResult.errors; track item.capteurId + '-' + item.step) {
            <li>Capteur #{{ item.capteurId }} - {{ item.step }}: {{ item.error }}</li>
          }
        </ul>
      }
    </section>
  }
</section>
